import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { debounce } from 'lodash';
import { postRequest } from '../interceptor/interceptor';
import moment from 'moment';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router';
import { RiProgress6Line } from 'react-icons/ri';
import { userLogoutOp } from '../../redux/operations/user.operations.js';
import CircularChart from '../CircularChart/CircularChart';
import StackedBarChart from '../BarChart/BarChart';
import NavigationTab from '../NavigationTab/NavigationTab.jsx';
import { Grid, Card, Typography, IconButton } from '@mui/material';
import { TICKET_STATS } from '../../apiConst';
import 'react-pivottable/pivottable.css';
import TicketsList from './TicketsList';
import 'react-datepicker/dist/react-datepicker.css';
import {
  dashboardTableHeader,
  grievanceTableHeader,
} from '../../Fields/grievanceFields';
import SelectDropdown from '../../Common/SelectDropdown';
import DateRangePicker from '../../Common/DateRangePicker.jsx';
import { FcClearFilters } from 'react-icons/fc';

const GrievanceDashboard = () => {
  const {
    register,
    getValues,
    setValue,
    formState: { errors },
  } = useForm({});

  const FilterOptions = grievanceTableHeader;

  const [isLoading, setIsLoading] = useState(false);
  const [isDisplay, setIsDisplay] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [totalCount, setTotalCount] = useState(rowsPerPage);
  const [tabsData, setTabsData] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [backlogCount, setBacklogCount] = useState(0);
  const [addressedCount, setAddressedCount] = useState(0);
  const [resolvedCount, setResolvedCount] = useState(0);
  const [rejectedCount, setRejectedCount] = useState(0);
  const [backlogData, setBacklogData] = useState([]);
  const [resolvedData, setResolvedData] = useState([]);
  const [addressedData, setAddressedData] = useState([]);
  const [rejectedData, setRejectedData] = useState([]);
  const navigate = useNavigate();
  const [searchVal, setSearchVal] = useState('');
  const [requestMode, setRequestMode] = useState(null);
  const [requestType, setRequestType] = useState(null);
  const [searchField, setSearchField] = useState('');
  const [pivotdata, setPivotdata] = useState([]);
  const dispatch = useDispatch();
  const [requestBarMode, setRequestBarMode] = useState('');
  const [requestCircularMode, setRequestCircularMode] = useState('');

  useEffect(() => {
    fetchListData();
    import('../../utils/taskNavTabs.js').then((data) => {
      setTabsData(data.taskNavTabs);
    });
  }, [startDate, endDate]);

  const onClearFilters = () => {
    setStartDate(null);
    setEndDate(null);
    setRequestMode('select');
    setRequestType('select');
    setValue('requestMode', 'select');
    setValue('requestType', 'select');
    setValue('searchField', '');
    setSearchVal('');
    fetchListData(1, rowsPerPage, '', 'select', 'select', null);
  };

  const fetchListData = (
    pg = 1,
    size = 10,
    search = '',
    selectedRequestMode = requestMode,
    selectedRequestType = requestType,
    searchKey = null
  ) => {
    setIsLoading(true);

    let payload = {};

    if (startDate) payload.startDate = moment(startDate).format('YYYY-MM-DD');
    if (endDate) payload.endDate = moment(endDate).format('YYYY-MM-DD');
    if (selectedRequestMode && selectedRequestMode !== 'select')
      payload.requestMode = selectedRequestMode;
    if (selectedRequestType && selectedRequestType !== 'select')
      selectedRequestMode === 'private'
        ? (payload.privateRequestType = selectedRequestType)
        : (payload.requestType = selectedRequestType);

    const currentSearchField = searchKey || getValues('searchField');

    // Use 'search' as key if no filter selected but search value exists
    const keyToUse =
      currentSearchField && currentSearchField !== ''
        ? currentSearchField
        : search
        ? 'search'
        : null;

    if (keyToUse && search) {
      payload[keyToUse] = search;
    }

    postRequest(TICKET_STATS, payload)
      .then((res) => {
        const {
          backlog_count,
          resolved_count,
          addressed_count,
          rejected_count,
          total,
          backlog,
          addressed,
          rejected,
          resolved,
        } = res.data;
        setPivotdata(res.data);
        setTotalCount(total);
        setBacklogCount(backlog_count);
        setAddressedCount(addressed_count);
        setResolvedCount(resolved_count);
        setBacklogData(backlog || []);
        setAddressedData(addressed || []);
        setResolvedData(resolved || []);
        setRejectedCount(rejected_count);
        setRejectedData(rejected || []);
        setIsLoading(false);
        setIsDisplay(true);
      })
      .catch(() => {
        setIsLoading(false);
        setBacklogCount(0);
        setAddressedCount(0);
        setResolvedCount(0);
        setRejectedCount(0);
        setBacklogData([]);
        setAddressedData([]);
        setResolvedData([]);
        setRejectedData([]);
        setTotalCount(0);
      });
  };

  const onEdit = (task) => {
    navigate('/stepper-form', {
      state: {
        data: {
          task: {
            ...task,
          },
        },
        isEdit: true,
      },
    });
  };
  const onView = (task) => {
    navigate('/stepper-form', {
      state: {
        data: {
          task: {
            ...task,
          },
        },
        isView: true,
      },
    });
  };
  const onStepperForm = (task) => {
    navigate('/stepper-form', {
      state: {
        data: {
          task: {
            ...task,
          },
        },
        isView: false,
      },
    });
  };
  const handleLogout = () => {
    dispatch(userLogoutOp());
    localStorage.removeItem('userAuthToken');
    localStorage.removeItem('locationIp');
    navigate('/seva-login');
  };

  const handleSearchFieldDropdown = (e) => {
    const selectedField = e.target.value;
    setValue('searchField', selectedField);
    setSearchField(selectedField);
    fetchListData(
      1,
      rowsPerPage,
      searchVal,
      requestMode,
      requestType,
      selectedField
    );
  };

  const handleRequestModeDropdown = (e) => {
    const selectedMode = e.target.value;
    setValue('requestMode', selectedMode);
    setRequestMode(selectedMode);
    fetchListData(1, rowsPerPage, searchVal, selectedMode, requestType);
    setRequestCircularMode(selectedMode === 'select' ? '' : selectedMode);
    setRequestBarMode(selectedMode === 'select' ? '' : selectedMode);
  };

  const handleRequestTypeDropdown = (e) => {
    const selectedType = e.target.value;
    setValue('requestType', selectedType);
    setRequestType(selectedType);
    fetchListData(1, rowsPerPage, searchVal, requestMode, selectedType);
    setRequestCircularMode(requestMode === 'select' ? '' : requestMode);
    setRequestBarMode(requestMode === 'select' ? '' : requestMode);
  };

  // Update debounce to pass 'search' as key if no filter selected
  const debounceSearch = debounce((searchValue) => {
    setSearchVal(searchValue);
    const currentSearchField = getValues('searchField');
    const keyToUse =
      currentSearchField && currentSearchField !== ''
        ? currentSearchField
        : 'search';
    fetchListData(
      1,
      rowsPerPage,
      searchValue,
      requestMode,
      requestType,
      keyToUse
    );
  }, 750);

  const handleChangeSearch = (e) => {
    debounceSearch(e.target.value);
  };

  const cancelSearch = () => {
    setSearchVal('');
    fetchListData(1, rowsPerPage, '');
  };

  const componentDisplay = () => {
    const cells = FilterOptions?.filter(
      (cell) =>
        cell.id === 'ticketNo' ||
        cell.id === 'applicantMobile' ||
        cell.id === 'requestTitle' ||
        cell.id === 'applicantName' ||
        cell.id === 'ticketCreatedBy' ||
        cell.id === 'assignedTo' ||
        cell.id === 'referralName'
    );

    return (
      <div className="text-center mb-[-15px]">
        {FilterOptions.length > 0 && (
          <SelectDropdown
            fieldName="searchField"
            options={cells}
            optionsLabelKey="label"
            optionsValueKey="id"
            register={register}
            onChange={handleSearchFieldDropdown}
            errors={errors}
            fieldType="select"
            className="min-h-[auto] w-full border-1 bg-light py-1.5 text-sm text-gray-900 bg-white-900 rounded-md pl-2 focus:outline-none focus:bg-white focus:text-gray-900"
            emptyOption={true}
          />
        )}
      </div>
    );
  };

  const stats = [
    {
      label: 'Total Grievances',
      value: totalCount || 0,
      color: '',
    },
    { label: 'Backlog', value: backlogCount || 0, color: '#c2410c' },
    { label: 'Addressed', value: addressedCount || 0, color: '#3b6089' },
    { label: 'Rejected', value: rejectedCount || 0, color: '#9f1239' },
    { label: 'Resolved', value: resolvedCount || 0, color: '#166534' },
  ];

  return (
    <div className="w-full">
      <Grid container spacing={1} className="p-2">
        <Grid item xs={12}>
          <Card elevation={2} className="p-2 bg-blueBg rounded-lg ">
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6} md={2}>
                <label className="block text-white font-medium text-sm mb-1">
                  Select Date
                </label>
                <DateRangePicker
                  setEndDate={setEndDate}
                  setStartDate={setStartDate}
                  startDate={startDate}
                  endDate={endDate}
                  maxDate={new Date()}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <label className="block text-white font-medium text-sm mb-1">
                  Request Mode
                </label>
                <SelectDropdown
                  fieldName="requestMode"
                  options={[
                    { label: 'Select', value: '' },
                    { label: 'State', value: 'state' },
                    { label: 'Central', value: 'central' },
                    { label: 'Private', value: 'private' },
                  ]}
                  optionsLabelKey="label"
                  optionsValueKey="value"
                  register={register}
                  onChange={handleRequestModeDropdown}
                  errors={errors}
                  fieldType="select"
                  className="w-full border bg-white py-1.5 text-sm text-gray-900 rounded-md pl-2 focus:outline-none focus:bg-white focus:text-gray-900"
                  emptyOption={false}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <label className="block text-white font-medium text-sm mb-1">
                  Request Type
                </label>
                <SelectDropdown
                  fieldName={
                    requestMode === 'private'
                      ? 'privateRequestType'
                      : 'requestType'
                  }
                  options={
                    requestMode === 'private'
                      ? [
                          { label: 'Select', value: '' },
                          {
                            label: 'Employment',
                            value: 'Employment',
                          },
                          {
                            label: 'Help/Assistance',
                            value: 'Help/Assistance',
                          },
                          {
                            label: 'Other',
                            value: 'other',
                          },
                        ]
                      : [
                          { label: 'Select', value: '' },
                          { label: 'Personal', value: 'personal' },
                          { label: 'Community', value: 'community' },
                          { label: 'Official', value: 'official' },
                          { label: 'Medical', value: 'medical' },
                          { label: 'Other', value: 'other' },
                        ]
                  }
                  optionsLabelKey="label"
                  optionsValueKey="value"
                  register={register}
                  onChange={handleRequestTypeDropdown}
                  errors={errors}
                  fieldType="select"
                  className="w-full border bg-white py-1.5 text-sm text-gray-900 rounded-md pl-2 focus:outline-none focus:bg-white focus:text-gray-900"
                  emptyOption={false}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <label className="block text-white font-medium text-sm mb-1">
                  Filter by
                </label>
                {componentDisplay ? (
                  componentDisplay()
                ) : (
                  <div className="h-10 bg-gray-100 rounded-md"></div>
                )}
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <label className="block text-white font-medium text-sm mb-1">
                  Search
                </label>
                <div className="relative">
                  <span className="absolute inset-y-0 left-3 flex items-center">
                    <svg
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                      className="w-5 h-5 text-gray-500"
                    >
                      <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                    </svg>
                  </span>
                  <input
                    type="search"
                    name="search"
                    onChange={handleChangeSearch}
                    className="w-full py-1 pl-10 pr-4 border border-gray-500 rounded-md focus:border-primary-500 shadow-sm"
                    placeholder="Search..."
                  />
                </div>
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                md={2}
                className="flex items-center justify-center"
              >
                <IconButton
                  onClick={onClearFilters}
                  title="Clear Filters"
                  className="text-white flex items-center space-x-1"
                >
                  <span>Clear Filters</span>
                  <FcClearFilters />
                </IconButton>
              </Grid>
            </Grid>
          </Card>
        </Grid>
        {/* Stats Section (Cards) */}
        <Grid item xs={12}>
          <Card elevation={2} className="bg-white rounded-lg p-3">
            <Grid
              container
              spacing={0}
              justifyContent="space-between"
              alignItems="stretch"
            >
              {stats.map((stat, index) => (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={2}
                  key={index}
                  style={{ padding: 0, margin: 0 }}
                >
                  <div className="text-center flex flex-col h-full justify-center">
                    <Typography
                      variant="subtitle1"
                      className="text-gray-800 font-medium mb-1"
                    >
                      {stat.label}
                    </Typography>
                    <Typography
                      variant="h6"
                      style={{ color: stat.color }}
                      className="font-extrabold capitalize"
                    >
                      {stat.value < 10
                        ? `0${stat.value || 0}`
                        : stat.value || 0}
                    </Typography>
                  </div>
                </Grid>
              ))}
            </Grid>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Card elevation={2} className="p-2 bg-white rounded-lg">
            <NavigationTab
              navTabs={tabsData}
              heading="Tickets"
              tab_1={
                <TicketsList
                  heading={false}
                  tableRowsData={backlogData}
                  getListData={fetchListData}
                  rowsPerPage={rowsPerPage}
                  setRowsPerPage={setRowsPerPage}
                  totalCount={totalCount}
                  page={page}
                  setPage={setPage}
                  onEdit={onEdit}
                  onView={onView}
                  onStepperForm={onStepperForm}
                  register={register}
                  errors={errors}
                />
              }
              tab_2={
                <TicketsList
                  heading={false}
                  tableRowsData={addressedData}
                  getListData={fetchListData}
                  rowsPerPage={rowsPerPage}
                  setRowsPerPage={setRowsPerPage}
                  totalCount={totalCount}
                  page={page}
                  setPage={setPage}
                  onEdit={onEdit}
                  onView={onView}
                  onStepperForm={onStepperForm}
                  register={register}
                  errors={errors}
                />
              }
              tab_3={
                <TicketsList
                  heading={false}
                  tableRowsData={rejectedData}
                  getListData={fetchListData}
                  rowsPerPage={rowsPerPage}
                  setRowsPerPage={setRowsPerPage}
                  totalCount={totalCount}
                  page={page}
                  setPage={setPage}
                  onEdit={onEdit}
                  onView={onView}
                  onStepperForm={onStepperForm}
                  register={register}
                  errors={errors}
                />
              }
              tab_4={
                <TicketsList
                  heading={false}
                  tableRowsData={resolvedData}
                  getListData={fetchListData}
                  rowsPerPage={rowsPerPage}
                  setRowsPerPage={setRowsPerPage}
                  totalCount={totalCount}
                  page={page}
                  setPage={setPage}
                  onEdit={onEdit}
                  onView={onView}
                  onStepperForm={onStepperForm}
                  register={register}
                  errors={errors}
                />
              }
            />
          </Card>
        </Grid>
        <Grid item xs={12} md={5}>
          <Card elevation={2} className="p-2 bg-white rounded-lg">
            <div className="flex flex-wrap justify-between rounded-xl items-center gap-2">
              <Typography
                variant="h6"
                className="text-gray-800 font-semibold flex items-center"
              >
                <RiProgress6Line className="mr-2" /> Ticket Chart
              </Typography>

              <div className="flex items-center space-x-2 font-montsettat">
                <label className="inline-flex items-center cursor-pointer">
                  <input
                    type="radio"
                    value=""
                    checked={requestCircularMode === ''}
                    onChange={() => setRequestCircularMode('')}
                    className="hidden peer"
                    name="requestCircularMode"
                    defaultChecked
                  />
                  <div className="px-3 py-1.5 rounded-full text-sm font-medium border border-gray-300 peer-checked:bg-blueBg peer-checked:text-white peer-checked:border-blueBg transition-all duration-200">
                    All
                  </div>
                </label>
                <label className="inline-flex items-center cursor-pointer">
                  <input
                    type="radio"
                    value="state"
                    checked={requestCircularMode === 'state'}
                    onChange={() => setRequestCircularMode('state')}
                    className="hidden peer"
                    name="requestCircularMode"
                  />
                  <div className="px-3 py-1.5 rounded-full text-sm font-medium border border-gray-300 peer-checked:bg-blueBg peer-checked:text-white peer-checked:border-blueBg transition-all duration-200">
                    State
                  </div>
                </label>

                <label className="inline-flex items-center cursor-pointer">
                  <input
                    type="radio"
                    value="central"
                    checked={requestCircularMode === 'central'}
                    onChange={() => setRequestCircularMode('central')}
                    className="hidden peer"
                    name="requestCircularMode"
                  />
                  <div className="px-3 py-1.5 rounded-full text-sm font-medium border border-gray-300 peer-checked:bg-blueBg peer-checked:text-white peer-checked:border-blueBg transition-all duration-200">
                    Central
                  </div>
                </label>

                <label className="inline-flex items-center cursor-pointer">
                  <input
                    type="radio"
                    value="private"
                    checked={requestCircularMode === 'private'}
                    onChange={() => setRequestCircularMode('private')}
                    className="hidden peer"
                    name="requestCircularMode"
                  />
                  <div className="px-3 py-1.5 rounded-full text-sm font-medium border border-gray-300 peer-checked:bg-blueBg peer-checked:text-white peer-checked:border-blueBg transition-all duration-200">
                    Private
                  </div>
                </label>
              </div>
            </div>

            <CircularChart
              ticketData={pivotdata}
              requestCircularMode={requestCircularMode}
            />
          </Card>
        </Grid>
        <Grid item xs={12} md={7}>
          <Card elevation={2} className="p-2 bg-white rounded-lg">
            <div className="flex flex-wrap justify-between items-center gap-2">
              <Typography
                variant="h6"
                className="text-gray-800 font-semibold flex items-center"
              >
                <RiProgress6Line className="mr-2" /> Ticket Stats
              </Typography>

              <div className="flex items-center space-x-2 font-montsettat">
                <label className="inline-flex items-center cursor-pointer">
                  <input
                    type="radio"
                    value=""
                    checked={requestBarMode === ''}
                    onChange={() => setRequestBarMode('')}
                    className="hidden peer"
                    name="requestBarMode"
                  />
                  <div className="px-3 py-1.5 rounded-full text-sm font-medium border border-gray-300 peer-checked:bg-blueBg peer-checked:text-white peer-checked:border-blueBg transition-all duration-200">
                    All
                  </div>
                </label>
                <label className="inline-flex items-center cursor-pointer">
                  <input
                    type="radio"
                    value="state"
                    checked={requestBarMode === 'state'}
                    onChange={() => setRequestBarMode('state')}
                    className="hidden peer"
                    name="requestBarMode"
                  />
                  <div className="px-3 py-1.5 rounded-full text-sm font-medium border border-gray-300 peer-checked:bg-blueBg peer-checked:text-white peer-checked:border-blueBg transition-all duration-200">
                    State
                  </div>
                </label>

                <label className="inline-flex items-center cursor-pointer">
                  <input
                    type="radio"
                    value="central"
                    checked={requestBarMode === 'central'}
                    onChange={() => setRequestBarMode('central')}
                    className="hidden peer"
                    name="requestBarMode"
                  />
                  <div className="px-3 py-1.5 rounded-full text-sm font-medium border border-gray-300 peer-checked:bg-blueBg peer-checked:text-white peer-checked:border-blueBg transition-all duration-200">
                    Central
                  </div>
                </label>

                <label className="inline-flex items-center cursor-pointer">
                  <input
                    type="radio"
                    value="private"
                    checked={requestBarMode === 'private'}
                    onChange={() => setRequestBarMode('private')}
                    className="hidden peer"
                    name="requestBarMode"
                  />
                  <div className="px-3 py-1.5 rounded-full text-sm font-medium border border-gray-300 peer-checked:bg-blueBg peer-checked:text-white peer-checked:border-blueBg transition-all duration-200">
                    Private
                  </div>
                </label>
              </div>
            </div>
            <StackedBarChart
              ticketData={pivotdata}
              requestBarMode={requestBarMode}
            />
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default GrievanceDashboard;
